import Context from "../../../context/Context";
import moment from "moment";

export function addDuration(dtStart,durationKey) {
  var m = moment(dtStart);
  if (durationKey === "thirtyMin") {
    m = m.add(30,"minute");
  } else if (durationKey === "oneHour") {
    m = m.add(1,"hour");
  } else if (durationKey === "oneAndAHalfHours") {
    m = m.add(90,"minute");
  } else if (durationKey === "twoHours") {
    m = m.add(2,"hour");
  } else if (durationKey === "twoAndAHalfHours") {
    m = m.add(150,"minute");
  } else if (durationKey === "threeHours") {
    m = m.add(3,"hour");
  }
  return m.toDate();
}

export function determineDurationKey(when) {
  return getDurationKey(new Date(when.start.date),new Date(when.end.date))
}

export function getDurationKey(dtStart,dtEnd) {
  let k = null;
  let m = moment.duration(dtEnd.getTime() - dtStart.getTime()).asMinutes();
  if (m === 30) {
    k = "thirtyMin";
  } else if (m === 60) {
    k = "oneHour";
  } else if (m === 90) {
    k = "oneAndAHalfHours";
  } else if (m === 120) {
    k = "twoHours";
  } else if (m === 150) {
    k = "twoAndAHalfHours";
  } else if (m === 180) {
    k = "threeHours";
  } else {
    let v1 = moment(dtStart).startOf("day").valueOf();
    let v2 = moment(dtEnd).endOf("day").valueOf();
    if (dtStart.getTime() === v1 && dtEnd.getTime() === v2) {
      k = "allDay";
    }
  }
  return k;
}

export function getMomentHourFormat(short) {
  let timeFormat = "H";
  let locale = Context.instance.lib.dojo.kernel.locale
  if (locale === "en" || locale === "en-us") {
    timeFormat = "h A"
    if (short) timeFormat = "h"
  }
  return timeFormat;
}

export function getMomentTimeFormat() {
  let timeFormat = "H:mm";
  let locale = Context.instance.lib.dojo.kernel.locale
  if (locale === "en" || locale === "en-us") timeFormat = "h:mm A"
  return timeFormat;
}

export function getTopOfHour() {
  var m = moment(new Date());
  //var roundDown = m.startOf("hour");
  if (m.minute() || m.second() || m.millisecond()) {
    m = m.add(1,"hour").startOf("hour")
  } else {
    m = m.startOf("hour");
  }
  return m.toDate();
}

export function getRangeClause(field,dtStart,dtEnd) {
  const start = getZulu(dtStart);
  const end = getZulu(dtEnd);
  let clause = "(" + field + " >= TIMESTAMP '" + start + "'";
  clause += " AND " + field + " <= TIMESTAMP '" + end + "')";
  return clause;
}

export function getZulu(date) {
  const lib = Context.getInstance().lib;
  const opts = {zulu: true};
  let v = lib.dojo.stamp.toISOString(date,opts);
  v = v.replace("T"," ").replace("Z","");
  return v;
}

export function toEndOfDay(date) {
  let dt = toStartOfDay(date);
  dt.setDate(dt.getDate() + 1);
  dt = new Date(dt.getTime() - 1);
  return dt;
}

export function toStartOfDay(date) {
  const dt = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  return dt;
}
